import styles from './AboutPage.module.css';

export const AboutPageAnimations = () => {
	return (
		<>
			<div className={styles.Wheels}>
				<div className={styles.SettingsWheel2}>
					<span className={styles.SettingsWheelSymbol2}>settings</span>
				</div>

				<div className={styles.SettingsWheel3}>
					<span className={styles.SettingsWheelSymbol3}>settings</span>
				</div>

				<div className={styles.SettingsWheel1}>
					<span className={styles.SettingsWheelSymbol1}>settings</span>
				</div>

				<div className={styles.SettingsWheel5}>
					<span className={styles.SettingsWheelSymbol5}>settings</span>
				</div>

				<div className={styles.SettingsWheel4}>
					<span className={styles.SettingsWheelSymbol4}>settings</span>
				</div>
			</div>
		</>
	);
};
